// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hr-sect[data-v-50ef24f4]{align-items:center;color:rgba(0,0,0,.35);display:flex;flex-basis:100%;font-weight:700;margin:8px 0}.hr-sect[data-v-50ef24f4]:after,.hr-sect[data-v-50ef24f4]:before{background:rgba(0,0,0,.35);content:\"\";flex-grow:1;font-size:0;height:1px;line-height:0px;margin:0 8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
